class BurgerButton
    constructor: (el) ->
        @.$el = el
        if !@.$el.classList.contains 'burger-button--bound'
            @.$el.classList.add 'burger-button--bound'
            @.InitEvents()
        return

    InitEvents: ->
        self = @
        @.$el.addEventListener 'click', (e) ->
            self.$el.classList.toggle 'burger-button--open'
            return
        return

BindBurgerButtons = ->
    document.querySelectorAll '.burger-button:not(.burger-button--bound)'
        .forEach (el) ->
            new BurgerButton el
            return
    return

window.addEventListener 'bind-components', BindBurgerButtons